import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { setClientStorage } from '@/api/generalApi';
import { ClientStorage } from '@/state/clientStorage/clientStorageTypes';
import { selectClientStorage } from '@/state/clientStorage/clientStorageSelectors';
import { setClientStorageState, setIsLoading } from '@/state/clientStorage/clientStorageSlice';
import { cloneDeep } from 'lodash';

const useSetFilters = (): {
    uploadFilters: (params: Partial<ClientStorage>) => Promise<boolean>;
} => {
    const dispatch = useDispatch();
    const allFilters = useSelector((state: RootState) => selectClientStorage(state));

    const uploadFilters = async (params: Partial<ClientStorage>): Promise<boolean> => {
        try {
            const resultParams = { ...cloneDeep(allFilters), ...cloneDeep(params) };
            const result = JSON.stringify(resultParams);
            const { data } = await setClientStorage({ metadata: result });
            dispatch(setClientStorageState(data.metadata));
            return true;
        } catch (error) {
            dispatch(setIsLoading(false));
            console.error(error);
            return false;
        }
    };

    return { uploadFilters };
};

export default useSetFilters;
